module.exports = __webpack_public_path__ + "img/AQX.d1df97da.png";